class BracingDialogComponent extends HTMLElement {

  constructor() {
    super()
    document.addEventListener('project-loaded', (event) => this.configure(event.detail))
    document.addEventListener('bracing-did-change', (event) => this.configure(event.detail))
  }

  configure(project) {
    
    if (project.design.bracingType === 'continuous') {
      document.getElementById('continuous-bracing-button').click()
    } else if (project.design.bracingType === 'equal') {
      document.getElementById('equally-spaced-bracing-button').click()
    } else if (project.design.bracingType == 'custom') {
      document.getElementById('custom-bracing-button').click()      
    } else if (project.design.bracingType == 'unbraced') {
      document.getElementById('unbraced-bracing-button').click()
    }
    // equally spaced form
    document.getElementById("equal-bracing-spacing-input").value = showSmallLengthWithUnits(project.design.getBraceSpacing())
    document.getElementById('equal-bracing-start-input').value = showSmallLengthWithUnits(project.design.getBracingStartLocation())
    // custom bracing table
    updateCustomBracingTable(project)
  }

  connectedCallback() {

    this.innerHTML = String.raw`

    <div class="modal fade" id="modal-bracing-dialog" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h1 class="modal-title fs-5" id="modal-bracing-dialog-label">Bracing</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="text-center d-flex justify-content-center">  
            <ul class="nav nav-pills selector-nav-pills mb-3" role="tablist">
              <li class="nav-item px-1" role="presentation">
                <button type="button" role="tab" class="nav-link selector-nav-link active show" id="continuous-bracing-button"
                  data-bs-toggle="tab" data-bs-target="#continuous-bracing-tab">Continuous
                </button>
              </li>
              <li class="nav-item px-1" role="presentation">
                <button type="button" role="tab" class="nav-link selector-nav-link" id="equally-spaced-bracing-button"
                data-bs-toggle="tab" data-bs-target="#equally-spaced-bracing-tab">Equally Spaced
                </button>
              </li>
              <li class="nav-item px-1" role="presentation">
                <button type="button" role="tab" class="nav-link selector-nav-link" id="custom-bracing-button"
                data-bs-toggle="tab" data-bs-target="#custom-bracing-tab">Custom
                </button>
              </li>
              <li class="nav-item px-1" role="presentation">
                <button type="button" role="tab" class="nav-link selector-nav-link" id="unbraced-bracing-button"
                data-bs-toggle="tab" data-bs-target="#unbraced-bracing-tab">Unbraced
                </button>
              </li>
            </ul>
          </div>

          <div class="modal-body">

            <div class="tab-content">
              <div class="tab-pane fade active show" role="tabpanel" id="continuous-bracing-tab"></div>

              <div class="tab-pane fade" role="tabpanel" id="equally-spaced-bracing-tab">
                <table class="table" id="equal-bracing-table">
                  <tr class="success">
                    <td style='width:100px;'>Spacing @:</td>
                    <td><input style='width:100px;' id='equal-bracing-spacing-input' type='text'
                        name='equal-bracing-spacing-input' value='0' onchange="onEqualSpacedBracingChange()"/>
                      O.C.</td>
                  </tr>
                  <tr class="success">
                    <td style='width:100px;'>Starting @:</td>
                    <td><input style='width:100px;' id='equal-bracing-start-input' type='text'
                        name='equal-bracing-start-input' value='0'  onchange="onEqualSpacedBracingChange()"/>
                      from left end</td>
                  </tr>
                </table>
              </div>

              <div class="tab-pane fade" role="tabpanel" id="custom-bracing-tab">
                <table class="table">
                  <tr class="success">
                    <td style="width:120px;">New Brace @:</td>
                    <td><input style="width:100px;" id="new-brace-location-input" type="text"
                        name="new-brace-location-input" value='0"' onchange="onNewBraceLocationChange()"></td>
                    <td><button id="add-brace-button" type="button" class="btn btn-sm btn-success"
                        onclick="onAddBrace()">Add</button>
                    </td>
                  </tr>
                </table>
                <div id="custom-bracing-table"></div>
              </div>

              <div class="tab-pane fade" role="tabpanel" id="unbraced-bracing-tab"></div>
            </div>        
          </div>
          
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    `

    document.getElementById('continuous-bracing-button').onclick = () => { document.dispatchEvent(new CustomEvent('bracing-changed', {detail: 'continuous'})) }
    document.getElementById('equally-spaced-bracing-button').onclick = () => { document.dispatchEvent(new CustomEvent('bracing-changed', {detail: 'equal'})) }
    document.getElementById('custom-bracing-button').onclick = () => { document.dispatchEvent(new CustomEvent('bracing-changed', {detail: 'custom'})) }
    document.getElementById('unbraced-bracing-button').onclick = () => { document.dispatchEvent(new CustomEvent('bracing-changed', {detail: 'unbraced'})) }
    
  }
}

customElements.define('bracing-dialog-component', BracingDialogComponent)

function onEqualSpacedBracingChange() {
  let equalSpacedBracing = {}
  let id = 'equal-bracing-spacing-input'
  if (validateRequiredInput(id) && validateLengthInput(id) && validateBraceSpacing(id)) {
    equalSpacedBracing.braceSpacing = wsParseLength(document.getElementById(id).value, "inches")
  } else { 
      return
  }
  id = 'equal-bracing-start-input'
  if (validateRequiredInput(id) && validateLengthInput(id) && validateBraceLocation(id)) {
    equalSpacedBracing.braceStart = wsParseLength(document.getElementById(id).value, "inches")
  } else { 
      return
  }
  document.dispatchEvent(new CustomEvent('equal-space-bracing-changed', {detail: equalSpacedBracing}))
}

function onNewBraceLocationChange() {
  let id = 'new-brace-location-input'
  if (validateRequiredInput(id) && validateLengthInput(id) && validateBraceLocation(id)) { }
}

function onAddBrace() {
  let id = 'new-brace-location-input'
  if (validateRequiredInput(id) && validateLengthInput(id) && validateBraceLocation(id)) {
    const location = wsParseLength(document.getElementById(id).value, "inches")
    document.dispatchEvent(new CustomEvent('add-new-brace', {detail: location}))
  }
}

function removeBrace(index) {
  document.dispatchEvent(new CustomEvent('remove-brace', {detail: index}))
}

function openModalBracingDialog() {
  document.dispatchEvent(new CustomEvent('configure-bracing-dialog'))
  bootstrap.Modal.getOrCreateInstance('#modal-bracing-dialog').show()
}

function updateCustomBracingTable(project) {
  // loop over braces and build a table showing them...
  let design = project.design
  let str = '<table class="table">'
  for (let i in design.customBraces) {
    if (design.customBraces[i].isSupport) {
      str += "<tr class='grayout'>";
      str += "<td style='width:100px;'>";
      str += "<span class='ws-ui-disabled-font'>Brace @</span>";
      str += "</td>";
      str += "<td style='width:100px;' id='brace_" + i + "'>" + showFeetInches(design.customBraces[i].x) + "</td>";
      str += "<td style='width:100px;'><span><em>Support</em></span></td></tr>";
    } else {
      str += "<tr>";
      str += "<td style='width:100px;'>";
      str += "Brace @";
      str += "</td>";
      str += "<td style='width:100px;' id='brace_" + i + "'>" + showFeetInches(design.customBraces[i].x) + "</td>";
      str += "<td style='width:100px;'><button type='button' class='btn btn-sm btn-danger' data-toggle='modal' onclick='removeBrace(" + i + ");'>Remove</button></td></tr>";
    }
  }
  str += "</table>";

  str += `
  <div class="alert alert-info" role="alert">
      <strong>Note:</strong> Supports assumed braced.
  </div>`
  document.getElementById('custom-bracing-table').innerHTML = str
}